var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.128 34.999h9.565a3.344 3.344 0 003.344-3.344V18.34a3.344 3.344 0 00-3.344-3.344h-9.565a3.344 3.344 0 00-3.344 3.344v13.316a3.345 3.345 0 003.344 3.343z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M12.244 29.284a3.517 3.517 0 01-2.481-3.36V12.838a3.515 3.515 0 013.515-3.515h9.426a3.5 3.5 0 012.386.934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySimple);
export default __webpack_public_path__ + "static/media/copySimple.77e81bd6fd71609721b55116fc0f4486.svg";
export { ForwardRef as ReactComponent };